<template>
  <div class="toaster-container">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="`shop-toast shop-toast-${toast.type}`"
    >
      <div class="toast-header">
        <strong>{{ toast.title }}</strong>
        <button class="toast-close" @click="removeToast(toast.id)">
          &times;
        </button>
      </div>
      <div class="toast-body">{{ toast.message }}</div>
    </div>
  </div>
  <div
    v-if="blockingModal"
    class="blocking-modal-overlay"
    role="dialog"
    aria-modal="true"
  >
    <div :class="`blocking-modal-content blocking-modal-${blockingModal.type}`">
      <div class="blocking-modal-title">{{ blockingModal.title }}</div>
      <div class="blocking-modal-body">{{ blockingModal.message }}</div>
      <div class="blocking-modal-actions">
        <button
          v-if="blockingModal.primaryLabel"
          type="button"
          class="btn btn-primary blocking-modal-primary"
          @click="runPrimaryAction"
        >
          {{ blockingModal.primaryLabel }}
        </button>
        <button
          type="button"
          class="btn btn-secondary blocking-modal-close"
          @click="closeBlockingModal"
        >
          Fermer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useToasterStore } from "@/store/toaster";

export default {
  name: "Toaster",
  mounted() {
    document.addEventListener("show-toast", this.onShowToast);
  },
  unmounted() {
    document.removeEventListener("show-toast", this.onShowToast);
  },
  computed: {
    toasts() {
      return useToasterStore().toasts;
    },
    blockingModal() {
      return useToasterStore().blockingModal;
    },
  },
  methods: {
    onShowToast(event) {
      if (!event?.detail) {
        return;
      }
      useToasterStore().addToast(event.detail);
    },
    removeToast(id) {
      useToasterStore().removeToast(id);
    },
    closeBlockingModal() {
      useToasterStore().closeBlockingModal();
    },
    runPrimaryAction() {
      const onPrimary = useToasterStore().blockingModal?.onPrimary;
      useToasterStore().closeBlockingModal();
      if (typeof onPrimary === "function") {
        onPrimary();
      }
    },
  },
};
</script>

<style scoped>
.toaster-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10002;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.blocking-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10003;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.blocking-modal-content {
  width: 100%;
  max-width: 560px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  padding: 24px;
}

.blocking-modal-danger {
  border-top: 5px solid #dc3545;
}

.blocking-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #212529;
}

.blocking-modal-body {
  color: #495057;
  margin-bottom: 16px;
}

.blocking-modal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.blocking-modal-close {
  min-width: 120px;
}

.shop-toast {
  min-width: 300px;
  max-width: 400px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease;
  display: block;
}

.shop-toast-danger {
  border-left: 4px solid #dc3545;
}

.shop-toast-success {
  border-left: 4px solid #28a745;
}

.shop-toast-warning {
  border-left: 4px solid #ffc107;
}

.toast-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
}

.toast-header strong {
  color: #333;
}

.toast-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.toast-body {
  padding: 15px;
  color: #666;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
